export default [
  {
    label: "Before 500",
    value: "Before 500"
  },
  {
    label: "501-1400",
    value: "501-1400"
  },
  {
    label: "1401-1500",
    value: "1401-1500"
  },
  {
    label: "1501-1600",
    value: "1501-1600"
  },
  {
    label: "1601-1700",
    value: "1601-1700"
  },
  {
    label: "1701-1800",
    value: "1701-1800"
  },
  {
    label: "1801-1900",
    value: "1801-1900"
  },
  {
    label: "1901-1950",
    value: "1901-1950"
  },
  {
    label: "1951-2000",
    value: "1951-2000"
  },
  {
    label: "2001-Present",
    value: "2001-Present"
  }
];
